import type { AvailabilityState } from './experiences-grid/types';

export const PLP_INTERACTION_TYPE = 'property landing page';

export const getPlpLayoutVariant = () =>
	typeof window !== 'undefined' && window.matchMedia?.('(min-width: 1100px)').matches
		? 'desktop'
		: 'mobile';

export function experienceAvailabilityDetail(
	state: AvailabilityState | undefined,
	isShown: boolean
): string {
	if (!isShown || !state) return 'na';
	switch (state) {
		case 'available':
			return 'available for your dates';
		case 'some':
			return 'available for some of your dates';
		case 'none':
			return 'not available for your dates';
	}
}
